import { useApi } from "src/hooks/useApi";
import type { InvoiceTemplate } from "src/helpers/invoiceTemplates";

/** The viewer's own and the practice's shared invoice templates, most used first (chapter 18).
 *  `enabled: false` loads nothing — for members who can't create invoices. */
export function useInvoiceTemplates(enabled = true) {
    const { data, loading, error, refetch } = useApi<{ templates: InvoiceTemplate[] }>(enabled ? "/invoice-templates" : null);
    return { templates: data?.templates ?? [], loading, error, refetch };
}
